import { CircleClose as o, CircleCheck as s, Loading as c, Close as l, InfoFilled as e, CircleCloseFilled as i, WarningFilled as n, SuccessFilled as a } from "./index537.js";
import { definePropType as r } from "./index601.js";
const f = r([
  String,
  Object,
  Function
]), p = {
  Close: l
}, _ = {
  Close: l
}, C = {
  primary: e,
  success: a,
  warning: n,
  error: i,
  info: e
}, u = {
  validating: c,
  success: s,
  error: o
};
export {
  p as CloseComponents,
  _ as TypeComponents,
  C as TypeComponentsMap,
  u as ValidateComponentsMap,
  f as iconPropType
};
